/**
 * Get localized string with fallback to Portuguese
 * If the requested locale is empty, falls back to pt-BR
 */
export function getLocalizedString(
  localizedObj: { 'pt-BR': string; 'en-US': string; 'es-ES': string } | undefined,
  locale: 'pt-BR' | 'en-US' | 'es-ES'
): string {
  if (!localizedObj) return '';

  const value = localizedObj[locale];

  // If value exists and is not empty, return it
  if (value && value.trim() !== '') {
    return value;
  }

  // Fallback to Portuguese
  return localizedObj['pt-BR'] || '';
}

/**
 * Get localized string array with fallback to Portuguese
 * If the requested locale is empty, falls back to pt-BR
 */
export function getLocalizedStringArray(
  localizedObj: { 'pt-BR': string[]; 'en-US': string[]; 'es-ES': string[] } | undefined,
  locale: 'pt-BR' | 'en-US' | 'es-ES'
): string[] {
  if (!localizedObj) return [];

  const value = localizedObj[locale];

  // Check if value exists, is an array, has items, and has at least one non-empty string
  if (value && Array.isArray(value) && value.length > 0) {
    const hasContent = value.some((item) => item && item.trim() !== '');
    if (hasContent) {
      return value;
    }
  }

  // Fallback to Portuguese
  return localizedObj['pt-BR'] || [];
}
